import React, { useState } from "react";
import { AddPatientModal, DeletePatientModal, DeleteProductModal, PatientContextMenu } from "./components/CnoModals";
import CnoPatientList from "./components/CnoPatientList";
import CnoPatientSheet from "./components/CnoPatientSheet";
import CreateDeliveryModal from "./components/CreateDeliveryModal";
import {
    cnoResponsiveCss,
    emptyStyle,
    errorStyle,
    headerStyle,
    pageStyle,
    primaryButtonStyle,
    secondaryButtonStyle,
    subtitleStyle,
    titleStyle,
    workspaceStyle,
} from "./components/cnoStyles";
import useCnoDeletions from "./hooks/useCnoDeletions";
import useCnoLines from "./hooks/useCnoLines";
import useCnoPatients from "./hooks/useCnoPatients";
import usePatientContextMenu from "./hooks/usePatientContextMenu";

function CnoHeader({ onAddPatient, onCreateDelivery }) {
    return (
        <div style={headerStyle}>
            <div>
                <h1 style={titleStyle}>CNO</h1>
                <p style={subtitleStyle}>Suivi des patients et des compléments nutritionnels oraux.</p>
            </div>
            <button type="button" onClick={onAddPatient} style={primaryButtonStyle}>
                Ajouter patient
            </button>
            <button type="button" onClick={onCreateDelivery} style={secondaryButtonStyle}>
                Créer une livraison
            </button>
        </div>
    );
}

export default function Cno() {
    const cno = useCnoPatients();
    const lines = useCnoLines(cno);
    const deletions = useCnoDeletions(cno);
    const contextMenu = usePatientContextMenu(cno.setSelectedPatientId);
    const [addPatientOpen, setAddPatientOpen] = useState(false);
    const [deliveryOpen, setDeliveryOpen] = useState(false);
    const { patients, selectedPatient } = cno;

    const lineActions = {
        readyCount: lines.cnoLinesReadyToSave.length,
        onUpdate: lines.updateCno,
        onDelete: deletions.setLineToDelete,
        onSave: lines.saveReadyCnos,
        onAdd: lines.addCno,
    };

    return (
        <div style={pageStyle}>
            <style>{cnoResponsiveCss}</style>

            <CnoHeader onAddPatient={() => setAddPatientOpen(true)} onCreateDelivery={() => setDeliveryOpen(true)} />

            {cno.saveError && <p role="alert" style={errorStyle}>{cno.saveError}</p>}
            {cno.loading && <p style={emptyStyle}>Chargement des fiches CNO...</p>}

            {!cno.loading && <div className="cno-workspace" style={workspaceStyle}>
                <CnoPatientList
                    patients={patients}
                    selectedPatientId={cno.selectedPatientId}
                    onSelect={cno.setSelectedPatientId}
                    onContextMenu={contextMenu.openMenu}
                />
                <main style={{ minWidth: 0 }}>
                    <CnoPatientSheet
                        patient={selectedPatient}
                        saveStatuses={cno.saveStatuses}
                        onContextMenu={contextMenu.openMenu}
                        onUpdatePatient={cno.updatePatient}
                        onSavePatient={cno.savePatient}
                        lineActions={lineActions}
                    />
                </main>
            </div>}

            {addPatientOpen && (
                <AddPatientModal
                    onClose={() => setAddPatientOpen(false)}
                    onCreated={fields => {
                        setAddPatientOpen(false);
                        cno.createPatient(fields);
                    }}
                />
            )}
            {deletions.lineToDelete && (
                <DeleteProductModal
                    line={deletions.lineToDelete}
                    deleting={deletions.deletingLine}
                    onClose={() => !deletions.deletingLine && deletions.setLineToDelete(null)}
                    onConfirm={deletions.confirmDeleteCno}
                />
            )}
            <PatientContextMenu
                menu={contextMenu.menu}
                onDelete={deletions.setPatientToDelete}
                onClose={contextMenu.closeMenu}
            />

            {deliveryOpen && (
                <CreateDeliveryModal
                    patients={patients}
                    onClose={() => setDeliveryOpen(false)}
                    onCreated={() => {
                        setDeliveryOpen(false);
                        cno.setSaveError("");
                    }}
                />
            )}
            {deletions.patientToDelete && (
                <DeletePatientModal
                    patient={deletions.patientToDelete}
                    deleting={deletions.deletingPatient}
                    onClose={() => !deletions.deletingPatient && deletions.setPatientToDelete(null)}
                    onConfirm={deletions.confirmDeletePatient}
                />
            )}
        </div>
    );
}
